module.exports = __webpack_public_path__ + "img/symbol-hand-center.d6d1f5ee.png";